import type { WizardStep } from './types'

export const LOCAL_LAST_WIZARD_STEP_KEYS = 'lase_wizard_step'

export const DOWNLOAD_CENTER_URL = 'https://www.miranow.ai/download'
export const CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/mira-web-addin/pnmgejapnfgmfclcbnmnpfgllgklpaig'
export const EDGE_EXTENSION_URL =
  'https://microsoftedge.microsoft.com/addons/detail/mira-timekeeping-ai-web/dnfddokmnhjicbeklkhfklbffenpkhce'

export const BROWSER_SECTIONS = [
  ['Open the Web Store', ['Go to the MIRA plugin page on the Web Store.']],
  [
    'Add MIRA to the browser',
    [
      'Click the "Add to Chrome/Edge" button.',
      'Confirm by clicking "Add Extension" in the pop-up window.',
    ],
  ],
  [
    'Pin the Extension (Optional but Helpful)',
    [
      'Click the puzzle piece icon in the top-right corner of the browser.',
      'Find MIRA in the list and click the pin icon to keep it visible on your toolbar.',
    ],
  ],
  [
    'Sign in',
    [
      'Click the MIRA icon in your toolbar.',
      'Sign in with Microsoft or Google.',
      'Enter your email and password.',
      'Grant any necessary permissions to allow MIRA to track your work hours.',
    ],
  ],
  [
    'Start Tracking',
    [
      'Once logged in, MIRA will begin tracking your time spent on different websites and tasks.',
      'You can manage your productivity directly from the extension.',
      `By default, Web Extension activities are automatically pushed to MIRA every hour. If you're working on a website for multiple projects or clients, select the appropriate project number, add a narrative, and manually push the activity to MIRA when you finish working on that specific project. This helps ensure your time is accurately recorded against the correct matter.`,
    ],
  ],
] as const

export const WELCOME_WIZARD_STEPS_KEY = {
  BestPractices: 'best-practices',
  CompletionChecklist: 'completion-checklist',
  ConfigureTracking: 'configure-tracking',
  DesktopAgentAccess: 'desktop-agent-access',
  Finish: 'finish',
  GettingStarted: 'getting-started',
  IdleDetection: 'idle-detection',
  InstallBrowserExtension: 'install-browser-extension',
  InstallDesktopAgent: 'install-desktop-agent',
  ManageEntries: 'manage-entries',
  ReassignMatters: 'reassign-matters',
  TimelinePanelTips: 'timeline-panel-tips',
  TimeEntryPanelTips: 'time-entry-panel-tips',
  WelcomeComplete: 'welcome-complete',
} as const

export const WELCOME_WIZARD_STEPS = [
  { key: WELCOME_WIZARD_STEPS_KEY.GettingStarted, label: 'Getting Started' },
  {
    children: [
      {
        key: WELCOME_WIZARD_STEPS_KEY.ConfigureTracking,
        label: 'Configure What You Track',
      },
      {
        key: WELCOME_WIZARD_STEPS_KEY.DesktopAgentAccess,
        label: 'How to access Desktop Agent',
      },
      {
        key: WELCOME_WIZARD_STEPS_KEY.IdleDetection,
        label: 'Idle Detection',
      },
    ],
    key: WELCOME_WIZARD_STEPS_KEY.InstallDesktopAgent,
    label: 'Install MIRA Desktop Agent',
  },
  {
    key: WELCOME_WIZARD_STEPS_KEY.InstallBrowserExtension,
    label: 'Install the MIRA Browser Extension',
  },
  {
    children: [{ key: WELCOME_WIZARD_STEPS_KEY.Finish, label: 'Finish' }],
    key: WELCOME_WIZARD_STEPS_KEY.CompletionChecklist,
    label: 'Completion Checklist',
  },
  {
    children: [
      {
        key: WELCOME_WIZARD_STEPS_KEY.BestPractices,
        label: 'Best Practices',
      },
    ],
    key: WELCOME_WIZARD_STEPS_KEY.TimelinePanelTips,
    label: 'Timeline Panel Tips',
  },
  {
    children: [
      {
        key: WELCOME_WIZARD_STEPS_KEY.ManageEntries,
        label: 'Manage Entries',
      },
      {
        key: WELCOME_WIZARD_STEPS_KEY.ReassignMatters,
        label: 'Change Matter Assignments',
      },
    ],
    key: WELCOME_WIZARD_STEPS_KEY.TimeEntryPanelTips,
    label: 'Time Entry Panel Tips',
  },
  {
    hidden: true,
    key: WELCOME_WIZARD_STEPS_KEY.WelcomeComplete,
    label: 'Welcome Complete',
  },
] satisfies WizardStep[]

export const WELCOME_WIZARD_STEP_SEQUENCE = WELCOME_WIZARD_STEPS.flatMap(
  step => [step, ...(step.children ?? [])]
)
